import { AgendaItemDetailModel } from "models/AgendaItemDetailModel";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { createContext } from "react";

export interface AgendaItemContextProps {
  agendaItems: AgendaItemDetailModel[] | undefined;
  setAgendaItems: (items: AgendaItemDetailModel[] | undefined) => void;
  selectAgendaItemId: number;
  setSelectAgendaItemId: (id: number) => void;
  confirmDeleteAgendaItem: ConfirmDeleteTarget | undefined;
  setConfirmDeleteAgendaItem: (target: ConfirmDeleteTarget | undefined) => void;
  isAgendaItemExpanded: (id: number, defaultValue?: boolean) => boolean;
  toggleAgendaItemExpanded: (id: number) => void;
  setAgendaItemExpanded: (id: number, newState: boolean) => void;
  isAgendaItemUpdating: (id: number) => boolean;
  setAgendaItemUpdating: (id: number, newState: boolean) => void;
  isAgendaItemDeleting: (id: number) => boolean;
  setAgendaItemDeleting: (id: number, newState: boolean) => void;
  onAgendaItemSortEnd: (oldIndex: number, newIndex: number) => void;
  allowDrag: boolean;
}

export const AgendaItemContext = createContext({} as AgendaItemContextProps);
